import $ from 'jquery'
import ParamTauxAssurance from '@/views/parametres/configs/param_taux_assurance'
import ManageConsumableItem from '@/views/parametres/configs/param-bon-consultations/manage-bon-consultation'
import UtilModal from '@/views/parametres/configs/param-bon-consultations/util-modal'
import configApi from '@/api/config/_user'

export default {
    name: 'param-bon-consultations',
    components: {
        ParamTauxAssurance, ManageConsumableItem,
        UtilModal
    },
    props: {
        section: { type: String, default: 'all' }
    },
    data() {
        return {
            divers: {
                duree_bon: '',
                calcul_diff_assur: 'Oui',        // ++++++++  Calcul differentiel   +++++++++
                show_recap_operation: 'Non',
                show_comment: 'Non',
                show_ref_facture: 'Non',
                format_ref_facture: 'point',
                defaut_date_facture: 'Oui'
            },

            consommable: {
                'carnet_sante': '', 'dossier_medical': '', 'livret_cpn': '',
                'carnet_cpn': '', 'carnet_vaccination': '', 'thermometre': '', 
                'apport_social': ''
            },
            is_loading: false,
            save_loading: false,
            save_conso_loading: false,
            cashier_expenses_enabled: false,
            cashier_authorizers: [],
            cashier_eligible: [],
            cashier_selected_ids: [],
            cashier_user_filter: '',
            show_cashier_authorizer_form: false,
            cashier_loading: false,
            cashier_saving: false,
            cashier_users_loading: false,
            cashier_users_saving: false,
            cashier_error: '',
            cashier_success: '',

            fields: [
				'consommable', 'prix', { key: 'types', label: 'Type.s' }, 
                { key: 'actions', label: 'Action.s' }
			],
			filter_conso: "",
			perPage: -1,
			currentPage: 1,
            liste_conso: [],

            conso_loading: true,
            conso_empty: false,

            c_prestation: {
				type_consultation_id: 0,
                categorie_id: 2,
				libelle: '',
			},
            is_edit: false,

            modal_title: 'Nouveau consommable',
            exist_error: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: [],

            selected_consumable: {
                consumable_id: 0,
                consumable_item: '',
                consumable_price: '',
                type_consultations: []
            },

            consumable_to_delete: {},

            
        }
    },
    computed: {
        list_consultations() {
            return this.$store.getters["list_consultations"];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },

        bon_consommables() {
            return this.$store.getters["bon_consommables"];
        },

        liste_all_bon_consommables() {
            return this.$store.getters["liste_all_bon_consommables"];
        },

        consumables_of_consultation() {
            return this.$store.getters["consumables_of_consultation"];
        },

        rows() {
            return this.consumables_of_consultation.length;
        },
        filteredCashierEligible() {
            const filter = this.cashier_user_filter.trim().toLocaleLowerCase()
            if (!filter) return this.cashier_eligible
            return this.cashier_eligible.filter(user =>
                `${user.name} ${user.titre || ''}`.toLocaleLowerCase().includes(filter))
        },
    },
    mounted() {
        // Liste des types de consultation
        this.$store.dispatch("getTousTypeConsultations")

        this.getDiversInfo()

        // Consommable bon de consultation
        this.getBonConsommable()

        this.listConsumableOfConsultation()
        if (this.section === 'all' || this.section === 'assurance-caisse') {
            this.loadCashierExpenseSettings()
        }
    },
    methods: {
        async loadCashierExpenseSettings() {
            this.cashier_loading = true
            this.cashier_error = ''
            try {
                const [setting, authorizers] = await Promise.all([
                    configApi.getCashierExpenseSettings(),
                    configApi.getCashierExpenseAuthorizers()
                ])
                this.cashier_expenses_enabled = setting.data.enabled === true
                this.cashier_authorizers = authorizers.data || []
            } catch (error) {
                this.cashier_error = 'Impossible de charger les dépenses caisse. Réessayez.'
            } finally {
                this.cashier_loading = false
            }
        },

        async saveCashierExpenseSettings() {
            this.cashier_saving = true
            this.cashier_error = ''
            this.cashier_success = ''
            try {
                const response = await configApi.updateCashierExpenseSettings({enabled: this.cashier_expenses_enabled})
                this.cashier_expenses_enabled = response.data.enabled === true
                this.cashier_success = 'Paramètre des dépenses caisse enregistré.'
            } catch (error) {
                this.cashier_error = 'Impossible d’enregistrer ce paramètre.'
            } finally {
                this.cashier_saving = false
            }
        },

        async openCashierExpenseAuthorizers() {
            this.cashier_users_loading = true
            this.cashier_error = ''
            try {
                const [eligible, selected] = await Promise.all([
                    configApi.getEligibleCashierExpenseAuthorizers(),
                    configApi.getCashierExpenseAuthorizers()
                ])
                this.cashier_eligible = eligible.data || []
                this.cashier_authorizers = selected.data || []
                this.cashier_selected_ids = this.cashier_authorizers.map(user => user.id)
                this.show_cashier_authorizer_form = true
            } catch (error) {
                this.cashier_error = 'Impossible de charger la liste des utilisateurs.'
            } finally {
                this.cashier_users_loading = false
            }
        },

        async saveCashierExpenseAuthorizers() {
            this.cashier_users_saving = true
            this.cashier_error = ''
            this.cashier_success = ''
            try {
                const response = await configApi.updateCashierExpenseAuthorizers({user_ids: this.cashier_selected_ids})
                this.cashier_authorizers = response.data || []
                this.show_cashier_authorizer_form = false
                this.cashier_success = 'Utilisateurs habilités enregistrés.'
            } catch (error) {
                this.cashier_error = 'Impossible d’enregistrer les utilisateurs habilités.'
            } finally {
                this.cashier_users_saving = false
            }
        },

        async getDiversInfo() {
            this.is_loading = true

            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {
                this.initFields()
            })
        },

        listConsumableOfConsultation() {
            this.conso_loading = true
            this.$store.dispatch('getConsumableOfConsultation', { hide_empty_price: 0 }).then(() => {
                if (this.consumables_of_consultation.length == 0) {
                    this.conso_empty = true
                } else {
                    this.conso_empty = false
                }
                this.conso_loading = false
            })
        },

        /**
         * Select consommable BON de consultation
         */
        getBonConsommable() {
            this.conso_loading = true

            this.$store.dispatch('getConfigInfoClinique', 'bon_consommable').then(() => {
                this.initBonConsoFields()
            })
        },

        initBonConsoFields() {
            const fld_keys = Object.keys(this.consommable);
            fld_keys.forEach((key) => {
                this.consommable[key] = (this.bon_consommables[key] != 'null' && this.bon_consommables[key] != null)?this.bon_consommables[key]:''
            });
        },

        initFields() {
            const fld_keys = Object.keys(this.divers);
            fld_keys.forEach((key) => {
                this.divers[key] = this.divers_info[key]

                this.is_loading = false
            });
        },

        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.list_consultations.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.list_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("consult-tous").checked = false;
        },

        async saveConfig() {
            const isValid = await this.$refs.divers_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            let form_data = new FormData();
            for (let key in this.divers) {
                form_data.append(key, this.divers[key])
            }
            form_data.append('data_type', 'divers_info')

            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.getDiversInfo()
                }

                this.save_loading = false
            })
        },

        async saveBonConsommable() {
            const isValid = await this.$refs.conso_form.validate();

            if (!isValid) {
                return;
            }

            this.save_conso_loading = true

            let form_data = new FormData();
            for (let key in this.consommable) {
                form_data.append(key, this.consommable[key])
            }
            form_data.append('data_type', 'bon_consommable')

            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.getBonConsommable()
                    this.listConsumableOfConsultation()

                    this.$refs.add_conso.click()
                }

                this.save_conso_loading = false
            })
        },

        newConsumable() {
            this.selected_consumable = {
                consumable_id: 0,
                consumable_item: '',
                consumable_price: '',
                type_consultations: []
            }
        },

        editConso(data) {
            this.selected_consumable = data
        },

        setToDelete(consumable_to_delete) {
            this.consumable_to_delete = consumable_to_delete
        },

        getConsoNameBySlug(slug) {
            var libelle = ''
            switch(slug) {
                case 'carnet_sante':
                    libelle = 'Carnet de santé'
                    break
                case 'dossier_medical':
                    libelle = 'Dossier médical'
                    break 
                case 'livret_cpn':
                    libelle = 'Livret CPN'
                    break
                case 'carnet_cpn': 
                    libelle = 'Carnet CPN'
                    break
                case 'carnet_vaccination': 
                    libelle = 'Carnet de vaccination'
                    break
                case 'thermometre':
                    libelle = 'Thermomètre'
                    break
                case 'apport_social':
                    libelle = 'Apport social'
                    break
            }

            return libelle
        },

        saveBonVisibility() { 
            if (this.one_is_checked.length == 0) {
                return ;
            }

            this.save_conso_loading = true

            let  data = {
                conso_bon_id: this.selected_consumable.conso_id,
                consultations: this.one_is_checked
            }

            this.$store.dispatch('saveConsommableBonVisibilite', data).then((response) => {
                if (response > 0) {
                    this.getBonConsommable()
                    this.listConsumableOfConsultation()

                    this.$refs.modal_conso.click()
                }

                this.save_conso_loading = false
            })
        }
    }
}


